import { Params } from '@angular/router';

export interface BreadcrumbItem {
  title: string;
  path: string;
  children?: Array<BreadcrumbItem>;
  showOnlyIfNotLast?: boolean;
  queryParams?: Params;
}

export const BreadcrumbItems: BreadcrumbItem[] = [
  {
    title: 'MENU.HOME',
    path: '/home',
  },
  {
    title: 'MENU.ACCOUNT',
    path: '/account',
  },
  {
    title: 'MENU.ACQUISITION',
    path: '/buying',
    children: [
      {
        title: 'MENU.MARKET',
        path: '/buying/search',
        children: [
          {
            title: 'MENU.PRODUCT_DETAILS',
            path: '/buying/search/product-details',
          },
        ],
      },
      {
        title: 'MENU.PURCHASES_OUTGOING',
        path: '/buying/purchase-lists',
        children: [
          {
            title: 'MENU.PURCHASE_DETAILS',
            path: '/buying/purchase-lists/details',
          },
        ],
      },
      // Így fog kinézni, amikor lesz "Rendelési listák" menü is:
      // {
      //   title: 'MENU.MY_ORDERS',
      //   rootUrl: 'buying/orders/purchase-lists',
      //   children: [
      //     {
      //       title: 'MENU.ORDER_LISTS',
      //       path: '/buying/orders/order-lists',
      //     },
      //     {
      //       title: 'MENU.PURCHASES_OUTGOING',
      //       path: '/buying/orders/purchase-lists',
      //     },
      //   ],
      // },
      {
        title: 'MENU.SORTIMENT',
        path: '/buying/sortiment/product-sortiment',
        children: [
          {
            title: 'MENU.SORTIMENT_VIEW',
            path: '/buying/sortiment/product-sortiment/view',
          },
          {
            title: 'MENU.SORTIMENT_PRICED',
            path: '/buying/sortiment/product-sortiment/selected-products',
          },
          {
            title: 'MENU.MARKET',
            path: '/buying/sortiment/product-sortiment/search',
          },
        ],
      },
      {
        title: 'MENU.VIP_DISCOUNTS_BREADCRUMB',
        path: '/buying/vip-discounts',
      },
      {
        title: 'MENU.ORDER_LIST',
        path: '/buying/order-list',
        children: [
          {
            title: 'MENU.OFFERS',
            path: '/buying/order-list/offers',
            children: [
              {
                title: 'MENU.OFFER_DETAILS',
                path: '/buying/order-list/offers/offer-details',
                children: [
                  {
                    title: 'MENU.OFFER_SUMMARY',
                    path: '/buying/order-list/offers/offer-details/summary',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'MENU.SELLING',
    path: '/selling',
    children: [
      {
        title: 'MENU.PURCHASES_INCOMING',
        path: '/selling/purchase-lists',
        children: [
          {
            title: 'MENU.PURCHASE_DETAILS',
            path: '/selling/purchase-lists/details',
          },
        ],
      },
      {
        title: 'MENU.SORTIMENT',
        path: '/selling/sortiment/product-sortiment',
        children: [
          {
            title: 'MENU.SORTIMENT_VIEW',
            path: '/selling/sortiment/product-sortiment/view',
          },
          {
            title: 'MENU.SORTIMENT_PRICED',
            path: '/selling/sortiment/product-sortiment/selected-products',
          },
          {
            title: 'MENU.SORTIMENT_START',
            path: '/selling/sortiment/product-sortiment/products-start',
            children: [
              {
                title: 'MENU.MARKET',
                path: '/selling/sortiment/product-sortiment/products-start/search',
              },
              {
                title: 'MENU.MARKET',
                path: '/selling/sortiment/product-sortiment/products-start/contact',
              },
              {
                title: 'MENU.PRODUCTS',
                path: '/selling/sortiment/product-sortiment/products-start/products',
                children: [
                  {
                    title: 'MENU.PRODUCTS_EDIT',
                    path: '/selling/sortiment/product-sortiment/products-start/products/edit',
                  },
                ],
              },
              {
                title: 'MENU.CONTAINERS',
                path: '/selling/sortiment/product-sortiment/products-start/containers',
                children: [
                  {
                    title: 'MENU.CONTAINERS_EDIT',
                    path: '/selling/sortiment/product-sortiment/products-start/containers/edit',
                  },
                ],
              },
              {
                title: 'MENU.PACKAGING',
                path: '/selling/sortiment/product-sortiment/products-start/packaging',
                children: [
                  {
                    title: 'MENU.PACKAGING_EDIT',
                    path: '/selling/sortiment/product-sortiment/products-start/packaging/edit',
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        title: 'MENU.PRICING',
        path: '/selling/prices/pricing/products',
        children: [
          {
            title: 'MENU.SELECTED_PRICING',
            path: '/selling/prices/pricing/selected-products',
          },
          {
            title: 'MENU.PRODUCT_DETAILS',
            path: '/selling/prices/pricing/products/view',
          },
        ],
      },
      {
        title: 'MENU.VIP_DISCOUNTS_BREADCRUMB',
        path: '/selling/prices/discounts/vip-discounts',
        children: [
          {
            title: 'MENU.PRODUCT_DETAILS',
            path: '/selling/prices/discounts/vip-discounts/product-view',
          },
          {
            title: 'MENU.VIP_SETTINGS',
            path: '/selling/prices/discounts/vip-discounts/settings',
          },
          {
            title: 'MENU.SORTIMENT_PRICED',
            path: '/selling/prices/discounts/vip-discounts/selected-products',
          },
        ],
      },
      {
        title: 'MENU.QUANTITY_DISCOUNTS_BREADCRUMB',
        path: '/selling/prices/discounts/quantity-discounts',
        children: [
          {
            title: 'MENU.PRODUCT_DETAILS',
            path: '/selling/prices/discounts/quantity-discounts/product-view',
          },
          {
            title: 'MENU.QUANTITY_SETTINGS',
            path: '/selling/prices/discounts/quantity-discounts/settings',
          },
          {
            title: 'MENU.SORTIMENT_PRICED',
            path: '/selling/prices/discounts/quantity-discounts/selected-products',
          },
        ],
      },
      {
        title: 'MENU.SEGMENT_DISCOUNTS_BREADCRUMB',
        path: '/selling/prices/discounts/segment-discounts',
      },
      {
        title: 'MENU.BASKET_DISCOUNTS_BREADCRUMB',
        path: '/selling/prices/discounts/basket-discounts',
      },
      {
        title: 'MENU.TENDERS',
        path: '/selling/tenders',
        children: [
          {
            title: 'MENU.TENDER_DETAILS',
            path: '/selling/tenders/tender-details',
          },
        ],
      },
      {
        title: 'MENU.DELIVERY',
        path: '/selling/delivery-mode',
        children: [
          {
            title: 'MENU.DELIVERY_EDIT',
            path: '/selling/delivery-mode/edit',
          },
          {
            title: 'MENU.DELIVERY_NEW',
            path: '/selling/delivery-mode/new',
          },
        ],
      },
    ],
  },
  {
    title: 'MENU.MERCHANT_BASIC_DATA',
    path: '/account/merchant',
    children: [
      {
        title: 'MENU.SITES',
        path: '/account/merchant/sites',
        showOnlyIfNotLast: true,
      },
      {
        title: 'MENU.SITES_CREATE',
        path: '/account/merchant/sites/create',
      },
      {
        title: 'MENU.SITES_EDIT',
        path: '/account/merchant/sites/edit',
      },
    ],
  },
  // Így fog kinézni, amikor lesz másik menüpont is a "Cég adatlap" mellett:
  // {
  //   title: 'MENU.MERCHANT_DATA',
  //   rootUrl: 'account/merchant',
  //   children: [
  //     {
  //       title: 'MENU.MERCHANT_BASIC_DATA',
  //       path: '/account/merchant',
  //     },
  //   ],
  // },
  {
    title: 'MENU.USERS',
    path: '/account/users',
    children: [
      {
        title: 'MENU.USERS_CREATE',
        path: '/account/users/creation',
      },
      {
        title: 'MENU.USERS_EDIT',
        path: '/account/users/edit',
      },
    ],
  },
];
